export default `
mutation endereco(
    $idProposta: String
    $cep: String
    $logradouro: String
    $numero: String
    $complemento: String
    $bairro: String
    $uf: String
    $cidade: String
    $cidadeId: Int
    $captchaResponse: String
  ) {
    enderecoFCG(
      payload: {
        id: $idProposta
        captchaResponse: $captchaResponse,
        endereco: {
          cep: $cep
          logradouro: $logradouro
          numero: $numero
          complemento: $complemento
          bairro: $bairro
          uf: $uf
          cidade: $cidade
          cidadeId: $cidadeId
        }
      }
    ) {
      dados {
        id
        situacaoProposta
      }
      validatorResponse {
        errors {
          message
          category
        }
      }
    }
  }
`;
